var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app-bar',{staticStyle:{"border-bottom":"3px solid #c0c0c0"},attrs:{"app":"","color":"#ffffff","clipped-left":"","flat":""}},[_c('span',{staticStyle:{"font-size":"0.7rem"}},[_c('strong',{staticClass:"text-sm-subtitle-1"},[_c('b',[_vm._v(_vm._s(_vm.contactName))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }